module.exports = __webpack_public_path__ + "assets/img/hill-4.e3e45568.png";